module.exports = __webpack_public_path__ + "static/media/further.8b362d1c.png";